// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oEJtdZWT1L0L5Mitn5Cr{flex-grow:1;margin:0 16px;display:flex;position:relative}.i9Nj2t6mYA86JO9zlflW{align-items:center;gap:4px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `oEJtdZWT1L0L5Mitn5Cr`,
	"enrolled": `i9Nj2t6mYA86JO9zlflW`
};
export default ___CSS_LOADER_EXPORT___;
